import { useMemo } from 'react';
import { MobilityKind } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const useMobilityFormValidator = () => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredString('kind'),
                validators.requiredString('title.defaultValue'),
                validators.requiredString('moduleId'),
                validators.only(
                    ({ kind }) => kind === MobilityKind.Addon,
                    validators.compose(
                        validators.requiredString('referenceName'),
                        validators.requiredBoolean('isChargeable')
                    )
                ),
                validators.requiredNumber('order'),
                validators.requiredBoolean('isActive')
            ),
        []
    );

    return useValidator(validator);
};

export default useMobilityFormValidator;
